// Мультиязычность RU (по умолчанию) + EN — docs/DECISIONS.md.
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  ru: {
    translation: {
      loading: "Загрузка…",
      days_short: "дн.",
      device_limit: "до {{count}} устройств",
      // Навигация (ТЗ раздел 3.3, 8 экранов)
      nav_plans: "Тарифы",
      nav_subscription: "Моя подписка",
      nav_devices: "Устройства",
      nav_change_plan: "Смена тарифа",
      nav_payments: "Платежи",
      nav_cancel: "Отмена",
      nav_promo: "Промокод",
      // Экран 1 — витрина тарифов
      plans_title: "Витрина тарифов",
      plans_error: "Не удалось загрузить тарифы — попробуйте позже.",
      plans_empty: "Тарифы временно недоступны.",
      plans_trial_via_promo: "активируется промокодом (/promo в боте)",
      buy: "Купить",
      // Экран 3 — моя подписка
      subscription_title: "Моя подписка",
      subscription_error: "Не удалось загрузить подписку — попробуйте позже.",
      subscription_none: "У вас нет активной подписки. Оформите на экране «Тарифы».",
      subscription_plan: "Тариф",
      subscription_status: "Статус",
      subscription_expires_at: "Действует до",
      status_active: "активна",
      status_expiring: "скоро истекает",
      status_expired: "истекла",
      status_cancelled: "отменена",
      devices_empty: "Устройства не привязаны.",
      // Экран 2 — оформление подписки
      checkout_title: "Оформление подписки",
      checkout_plan_not_found: "Тариф не найден или недоступен.",
      checkout_payment_method: "Оплата через Telegram Payments.",
      checkout_pay: "Оплатить",
      checkout_payment_failed: "Оплата не прошла — попробуйте ещё раз.",
      // Экран 4 — устройства
      devices_title: "Устройства",
      devices_primary: "основное",
      devices_show_links: "Ссылки на установку",
      devices_detach: "Отвязать",
      devices_links_pending: "Ссылки появятся чуть позже — попробуйте обновить.",
      devices_name_placeholder: "Название устройства",
      devices_attach: "Привязать новое",
      devices_limit_reached: "Достигнут лимит устройств тарифа — оформите апгрейд на экране «Смена тарифа».",
      devices_new_links_title: "Устройство привязано, скачайте антивирус:",
      // Заглушки ещё не реализованных экранов
      stub_not_ready: "Этот экран ещё не реализован.",
      change_plan_title: "Смена тарифа",
      payments_title: "История платежей",
      cancel_title: "Отмена подписки",
      promo_title: "Промокод",
    },
  },
  en: {
    translation: {
      loading: "Loading…",
      days_short: "days",
      device_limit: "up to {{count}} devices",
      nav_plans: "Plans",
      nav_subscription: "My subscription",
      nav_devices: "Devices",
      nav_change_plan: "Change plan",
      nav_payments: "Payments",
      nav_cancel: "Cancel",
      nav_promo: "Promo code",
      plans_title: "Plans",
      plans_error: "Failed to load plans — please try again later.",
      plans_empty: "No plans available right now.",
      plans_trial_via_promo: "activated via promo code (/promo in the bot)",
      buy: "Buy",
      subscription_title: "My subscription",
      subscription_error: "Failed to load your subscription — please try again later.",
      subscription_none: "You don't have an active subscription. Get one on the Plans screen.",
      subscription_plan: "Plan",
      subscription_status: "Status",
      subscription_expires_at: "Valid until",
      status_active: "active",
      status_expiring: "expiring soon",
      status_expired: "expired",
      status_cancelled: "cancelled",
      devices_empty: "No devices attached.",
      checkout_title: "Checkout",
      checkout_plan_not_found: "Plan not found or unavailable.",
      checkout_payment_method: "Payment via Telegram Payments.",
      checkout_pay: "Pay",
      checkout_payment_failed: "Payment failed — please try again.",
      devices_title: "Devices",
      devices_primary: "primary",
      devices_show_links: "Install links",
      devices_detach: "Detach",
      devices_links_pending: "Links will appear shortly — try refreshing.",
      devices_name_placeholder: "Device name",
      devices_attach: "Attach new",
      devices_limit_reached: "Plan device limit reached — upgrade on the Change plan screen.",
      devices_new_links_title: "Device attached, download the antivirus:",
      stub_not_ready: "This screen isn't implemented yet.",
      change_plan_title: "Change plan",
      payments_title: "Payment history",
      cancel_title: "Cancel subscription",
      promo_title: "Promo code",
    },
  },
};

void i18n.use(initReactI18next).init({
  resources,
  lng: "ru",
  fallbackLng: "ru",
  interpolation: { escapeValue: false },
});

export default i18n;
